import * as React from 'react';
export const useToggle = (initialState = false) => {
    const [state, setState] = React.useState(initialState);
    const handlers = {
        on: () => setState(true),
        off: () => setState(false),
        toggle: () => setState((s) => !s),
        reset: () => setState(initialState),
    };
    return [state, handlers];
};
//# sourceMappingURL=useToggle.js.map